<div class="snapshot-container">
  <div class="banner">
    {{ "taxReturns.viewing-snapshot" | transloco }}
    @if (status.phase.badge) {
    <span class="status">
      <span
        class="phase-badge"
        [ngClass]="status.phase.id"
        [title]="status.phase.name"
      >
        <span class="badge-text">{{ status.phase.badge }}</span>
      </span>
      <span class="status-name">{{ status.snapshotName }}</span>
    </span>
    } @if (!status.phase.badge) {
    <span class="status status-name">
      {{ status.snapshotName }}
    </span>
    } at {{ snapshot.createdAtStr }}
  </div>
</div>
